import React from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const propertyId = params.get("property_id");
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="border-border/60 p-8 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-500/15 text-amber-600 flex items-center justify-center mb-4">
          <XCircle className="w-8 h-8" />
        </div>
        <h1 className="font-heading text-2xl font-semibold">Pagamento annullato</h1>
        <p className="text-muted-foreground text-sm mt-2">Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.</p>
        <Button className="mt-6 w-full" onClick={() => navigate(propertyId ? `/properties/${propertyId}` : "/properties")} data-testid="back-to-property">
          Torna all'opportunità
        </Button>
      </Card>
    </div>
  );
}
